﻿﻿export interface ILogisticsOption {
    id: number;
    chainId: number;
    clusterNumber: number;
    positionNumber: number;
    optionNumber: number;
    kidneyPickupDateTime: string;
    kidneyPickupDateTimeBackup: string;
    kidneyPickupDateTimeTz: string;
    flightRouteOrGround: string;
    flightRouteOrGroundBackup: string;
    transportMethod: number;
    transportMethodBackup: number;
    transportCost: string;
    transportCostBackup: string;
    flightCarrierAndNumber: string;
    flightCarrierAndNumberBackup: string;
    flightDepartureTime: string;
    flightDepartureTimeTz: string;
    flightDepartureTimeBackup: string;
    flightDepartureTimeBackupTz: string;
    flightArrivalTime: string;
    flightArrivalTimeTz: string;
    flightArrivalTimeBackup: string;
    flightArrivalTimeBackupTz: string;
    flightLeg2DepartureTime: string;
    flightLeg2DepartureTimeTz: string;
    flightLeg2DepartureTimeBackup: string;
    flightLeg2DepartureTimeBackupTz: string;
    flightLeg2ArrivalTime: string;
    flightLeg2ArrivalTimeTz: string;
    flightLeg2ArrivalTimeBackup: string;
    flightLeg2ArrivalTimeBackupTz: string;
    kidneyArrivalDateTime: string;
    kidneyArrivalDateTimeBackup: string;
    kidneyArrivalDateTimeTz: string;
    upCharge: string;
    upChargeBackup: string;
    totalCost: number;
    totalCostBackup: number;
    status: number;
}
